"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomTrayRendererContent = exports.BottomTrayRenderer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BottomTrayRenderer = _styledComponents["default"].div.withConfig({
  displayName: "BottomTrayRendererstyle__BottomTrayRenderer",
  componentId: "sc-1odwp0a-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:block;position:relative;inset:0;z-index:", ";"], props.zIndex);
});

exports.BottomTrayRenderer = BottomTrayRenderer;

var BottomTrayRendererContent = _styledComponents["default"].div.withConfig({
  displayName: "BottomTrayRendererstyle__BottomTrayRendererContent",
  componentId: "sc-1odwp0a-1"
})(function (props) {
  var _props$bottomTrayRend = props.bottomTrayRendererTheme.appearance[props.appearance],
      backgroundColor = _props$bottomTrayRend.backgroundColor,
      color = _props$bottomTrayRend.color;
  return (0, _styledComponents.css)(["position:fixed;inset:auto 0 0;z-index:", ";width:100%;max-width:100%;max-height:100%;overflow-y:auto;background-color:", ";color:", ";border-top-left-radius:", ";border-top-right-radius:", ";box-shadow:0 2px 8px 0 rgb(0 0 0 / 16%);", ""], props.zIndex + 1, backgroundColor, color, props.theme.border.radius[2], props.theme.border.radius[2], (0, _coreMixins.advancedSpacing)('padding', props.isClosable ? [10, 5, 5] : [5]));
});

exports.BottomTrayRendererContent = BottomTrayRendererContent;
//# sourceMappingURL=BottomTrayRenderer.style.js.map